import { render, staticRenderFns } from "./ArticleSlide.vue?vue&type=template&id=efbd1f7c"
import script from "./ArticleSlide.vue?vue&type=script&lang=js"
export * from "./ArticleSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports